export default __webpack_public_path__ + "static/media/Meals4MeMarketing.59c8cc58.png";